import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6jbk8zuc: FaireBrandEntity = {
  token: "b_6jbk8zuc",
  type: "brand",
  name: "Amsha",
  avatarUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/0c0a0fe4bccf3e443320fb45d230e181b29fa6175d5f8ece029ddd4896607089/1566069459.jpg",
  bannerUrl: "https://cdn.faire.com/fastly/cac9a5a76c4218eed7da58b9404601ed5520804288c4ba08d45caf6deddcae94.jpeg",
  logoUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/0c0a0fe4bccf3e443320fb45d230e181b29fa6175d5f8ece029ddd4896607089/1566069459.jpg",
  heroImageUrl: "https://cdn.faire.com/fastly/cac9a5a76c4218eed7da58b9404601ed5520804288c4ba08d45caf6deddcae94.jpeg",
  location: "Columbia, SC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 404,
  isTopShop: true,
  isInsider: true,
  description: "**We're out of office to visit our artisans! Follow along on IG at @amshastudio. Please note the following important dates:\nMonday, August 24th: Studio re-opens for orders.\nMonday, September 14th: Orders start shipping out!**\nBased in South Carolina, Amsha works directly with artisans across Africa. We focus on driving social change in underserved communities by bringing quality, ethically made goods to the marketplace.  We know this is only the beginning for Amsha and for our artisans. Much of our story is still waiting to be written.",
  meta: {
    source: "api",
    importedAt: "2026-10-09T07:53:33.937Z",
    importedBy: "entity-db-cli"
  }
};
